// extracted by mini-css-extract-plugin
export default {"sbs-arrow":"_3_zZs","sbsArrow":"_3_zZs","sbs-arrow-hand":"_1H6_h","sbsArrowHand":"_1H6_h","label":"_5v3qw"};